import { AxiosResponse } from 'axios';

import { ApiVersion } from '@/config';
import { IAddress, IAddressForm } from '@/models';

import { http } from './http';
import { IAddressPreplanResponse, IGetParams, IListResponse } from './types';

export const AddressApi = {
  getAddresses: (
    params?: IGetParams,
  ): Promise<AxiosResponse<IListResponse<IAddress>>> => {
    return http.get(`api/${ApiVersion.V1}/address`, { params });
  },
  createAddress: (data: IAddressForm): Promise<AxiosResponse<IAddress>> => {
    return http.post(`api/${ApiVersion.V1}/address`, data);
  },
  updateAddress: ({
    _id,
    ...data
  }: IAddressForm): Promise<AxiosResponse<IAddress>> => {
    return http.put(`api/${ApiVersion.V1}/address/${_id}`, data);
  },
  getPreplan: async (
    addressId: string,
    agencyIds: string[],
  ): Promise<AxiosResponse<IAddressPreplanResponse>> => {
    return http.get(`api/${ApiVersion.V1}/address/${addressId}/preplan`, {
      params: { agencyIds: agencyIds.join(',') },
    });
  },
};
